import { Container } from '../content';
import style from '../../styles/header.module.scss';
import { useState } from 'react';
import { useAuth } from '../../context/useAuth';
import { Dropdown } from 'antd';
import ProfileCard from '../cards/ProfileCard';
import HeaderMobileMenu from './HeaderMobileMenu';
import { usePermissions } from '../../context/PermissionsContext';

const Header = () => {
  const { user } = useAuth();

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const { visibleMenuGroups } = usePermissions();
  const hasAdminMenu = visibleMenuGroups.length > 0;

  return (
    <header
      className={`${style.header} ${hasAdminMenu ? style.header__withSidebar : ''}`}
    >
      <Container
        className={`${style.header__container} ${hasAdminMenu ? style.header__container__fluid : ''}`}
      >
        {/* <Link className={style.header__container__link} to="/"> */}
        <img
          className={style.header__container__logo}
          src="/logo.svg"
          alt="logo"
          height={42}
          width={42}
        />
        {/* </Link> */}
        <div className={style.header__right}>
          <Dropdown
            open={isDropdownVisible}
            onOpenChange={(visible) => setIsDropdownVisible(visible)}
            trigger={['click']}
            popupRender={() => (
              <ProfileCard onOpenModal={() => setIsDropdownVisible(false)} />
            )}
            className={style.header__right__profileDropdown}
          >
            <div
              style={{
                cursor: 'pointer',
                padding: user?.profileImage ? '0' : '8px',
              }}
              className={style.header__imageContainer}
            >
              <img
                src={user?.profileImage || '/assets/icons/user.svg'}
                alt="user_icon"
              />
            </div>
          </Dropdown>
          {hasAdminMenu && <HeaderMobileMenu menuGroups={visibleMenuGroups} />}
          {/* <Dropdown
            open={isDropdownVisible}
            onOpenChange={(visible) => setIsDropdownVisible(visible)}
            trigger={['click']}
            popupRender={() => (
              <ProfileCard onOpenModal={() => setIsDropdownVisible(false)} />
            )}
            className={style.header__right__navDropdown}
          >
            <div
              style={{
                cursor: 'pointer',
                padding: user?.profileImage ? '0' : '8px',
              }}
              className={style.header__imageContainer}
            >
              <img
                src={user?.profileImage || '/assets/icons/user.svg'}
                alt="user_icon"
              />
            </div>
          </Dropdown> */}
        </div>
      </Container>
    </header>
  );
};

export default Header;
